// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-msel-chbox{width:100%}.app-msel-chbox .v-input__control{width:100%}.app-msel-chbox.v-input--selection-controls.v-input .v-label{display:block}.field-wrapper .v-select__selections{display:block;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width:100px}", ""]);
// Exports
module.exports = exports;
